
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/finance",
      function () {
        return require("private-next-pages/cases/finance/index.tsx");
      }
    ]);
  